import ClosedDashboard from "./ClosedDashboard";
import { Provider } from "react-redux";
import { store, persistor } from "../../store/store";
import { PersistGate } from 'redux-persist/integration/react'
import React from "react";
import { EventTypeProvider } from "../../providers/EventTypeProvider";
import { AuthenticationProvider } from "meportal/AuthenticationProvider";
import { ApplicationAuthorizationProvider, ApplicationAuthorized } from "meportal/AuthorizationProvider";
import { ConversationClientProvider } from "meconversation/ConversationClientProvider";
import { ToastProvider } from "../../providers/ToastProvider";

function ClosedEvents() {
  
  return (

    <Provider store={store}>
       <PersistGate loading={null} persistor={persistor}> 
        <ToastProvider>
          <AuthenticationProvider>
            <ApplicationAuthorizationProvider appName="OTSClosedEvents" >
              <ApplicationAuthorized showUnauthorizedPage={true}>
                <ConversationClientProvider>
                  <EventTypeProvider eventTypeName={""}>
                    <ClosedDashboard /> 
                  </EventTypeProvider>
                </ConversationClientProvider>
                </ApplicationAuthorized>
              </ApplicationAuthorizationProvider>
          </AuthenticationProvider>
         </ToastProvider>
       </PersistGate>
    </Provider>
  );
}

export default ClosedEvents
